module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-rating-content-imitation.b4fb59a4.svg";